import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { SvgIcon, SvgFill } from '@chegg-ui/svg-icon';
var Keyboard = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement(SvgFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.092 10.475a.37.37 0 0 0-.367.367v23.156a.37.37 0 0 0 .367.368H41.92a.36.36 0 0 0 .356-.368V10.843a.37.37 0 0 0-.367-.368H2.091ZM0 10.842C0 9.688.938 8.75 2.092 8.75h39.816c1.154 0 2.092.938 2.092 2.092v23.156a2.084 2.084 0 0 1-2.081 2.093H2.093A2.094 2.094 0 0 1 0 33.998V10.843Z"
  }), /*#__PURE__*/React.createElement(SvgFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.312 16.062c0-.476.386-.862.862-.862h3.081a.862.862 0 1 1 0 1.724H6.174a.862.862 0 0 1-.862-.862ZM14.832 16.062c0-.476.385-.862.862-.862h3.092a.862.862 0 1 1 0 1.724h-3.092a.862.862 0 0 1-.863-.862ZM24.363 16.062c0-.476.386-.862.862-.862h3.093a.862.862 0 1 1 0 1.724h-3.093a.862.862 0 0 1-.862-.862ZM33.894 16.062c0-.476.386-.862.862-.862h3.081a.862.862 0 1 1 0 1.724h-3.08a.862.862 0 0 1-.863-.862ZM5.312 21.868c0-.476.386-.862.862-.862h3.081a.862.862 0 1 1 0 1.725H6.174a.862.862 0 0 1-.862-.863ZM14.832 21.868c0-.476.385-.862.862-.862h3.092a.862.862 0 1 1 0 1.725h-3.092a.862.862 0 0 1-.863-.863ZM24.363 21.868c0-.476.386-.862.862-.862h3.093a.862.862 0 1 1 0 1.725h-3.093a.862.862 0 0 1-.862-.863ZM33.894 21.868c0-.476.386-.862.862-.862h3.081a.862.862 0 1 1 0 1.725h-3.08a.862.862 0 0 1-.863-.863ZM5.312 28.778c0-.476.386-.862.862-.862h31.663a.862.862 0 0 1 0 1.724H6.174a.862.862 0 0 1-.862-.862Z"
  }));
});
Keyboard.displayName = 'Keyboard';
Keyboard.defaultProps = {
  'aria-label': 'Keyboard'
};
export default Keyboard;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg-ui/horizon-icons/dist/esm/icons/Web/Keyboard.js
// module id = 3192
// module chunks = 11